<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/belongs/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="post_name_label detail_label">
            {{ postNameLabel }}
          </div>
          <div class="post_name detail_top_title">
            {{ postName }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="post_id_label detail_label">
            {{ postIdLabel }}
          </div>
          <div class="post_id">
            {{ postId }}
          </div>
          <div class="post_code_label detail_label">
            {{ postCodeLabel }}
          </div>
          <div class="post_code">
            {{ postCode }}
          </div>
          <div class="post_parent_label detail_label">
            {{ postParentLabel }}
          </div>
          <div class="post_parent">
            {{ parentPostName }}
          </div>
          <div class="users__label detail_label">
            {{ usersLabel }}
          </div>
          <div class="users disable_scroll_bar">
            <ul>
              <li v-for="user in users" :key="user.userId">
                <div v-if="user.postPriorityFlag">
                  {{ user.userName }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      postIdLabel: '所属ID',
      postNameLabel: '所属名',
      usersLabel: '表示拠点',
      postCodeLabel: '所属コード',
      postParentLabel: '親所属'
    }
  },
  computed: {
    postId() {
      return this.$store.state.belongs.post.postId
    },
    postName() {
      return this.$store.state.belongs.post.postName
    },
    users() {
      return this.$store.state.belongs.post.users
    },
    postCode() {
      return this.$store.state.belongs.post.postCode
    },
    parentPostName() {
      return this.$store.state.belongs.post.parentPostName
    }
  }
}
</script>

<style scoped>
.users {
  height: 60%;
  overflow-y: scroll;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/belongs/belongDetail.vue